import { render, staticRenderFns } from "./ProblemsSection.vue?vue&type=template&id=5fb1fd8a&scoped=true"
import script from "./ProblemsSection.vue?vue&type=script&lang=js"
export * from "./ProblemsSection.vue?vue&type=script&lang=js"
import style0 from "./ProblemsSection.vue?vue&type=style&index=0&id=5fb1fd8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb1fd8a",
  null
  
)

export default component.exports